import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Vuex from 'vuex'
import 'es6-promise/auto'
import VDateRange from 'vuetify-daterange-picker'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import VueNativeSock from 'vue-native-websocket'

Vue.use(VueNativeSock, 'wss://www.msoma.net/thermocouple-services/tc/websocket', { connectManually: true, store: store, format: 'json', reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 3000 })
Vue.use(router)
Vue.use(Vuetify)
Vue.use(Vuex)
Vue.use(VDateRange)


const store = new Vuex.Store({
  state: {
    authenticated: false,
    socketConnected: false,
    loggedInUser: "",
    userPassword: "",
    accountHeader: "X-mas-account",
    userHeader: "X-mas-user",
    serviceUser: "masServicesUser",
    servicePassword: "axs4MasServices!",
    authToken: "",
    setSessionId: -1,
    selectedLocation: { "name": "Select" },
    selectedKiln: { "name": "Select" },
    servicesHost: "https://www.msoma.net",
    secureHost: "https://www.msoma.net",
    range: []
  },
  getters: {
    getAuthenticated: state => {
      return state.authenticated
    },
    getSocketConnected: state => {
      return state.socketConnected
    },
    getLoggedInUser: state => {
      return state.loggedInUser
    },
    getUserPassword: state => {
      return state.userPassword
    },
    getAuthToken: state => {
      return state.authToken
    },
    getAccountHeader: state => {
      return state.accountHeader
    },
    getUserHeader: state => {
      return state.userHeader
    },
    getSelectedLocation: state => {
      return state.selectedLocation
    },
    getSelectedKiln: state => {
      return state.selectedKiln
    },
    getRange: state => {
      return state.range
    },
    getSessionId: state => {
        return state.sessionId
    }
  },
  mutations: {
    setAuthenticated (state, value) {
      state.authenticated = value
    },
    setSocketConnected (state, value) {
      state.socketConnected = value
    },
    setLoggedInUser (state, value) {
      state.loggedInUser = value
    },
    setUserPassword (state, value) {
      state.userPassword = value
    },
    setAuthToken (state, value) {
      state.authToken = value
    },
    setSelectedLocation (state, value) {
      state.selectedLocation = value
    },
    setSelectedKiln (state, value) {
      state.selectedKiln = value
    },
    setRange (state, value) {
      state.range = value
    },
    setSessionId (state, value) {
      state.sessionId = value
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')